import { CronosClearErrorsAction, CronosListProjectsAction, CronosListTeamsAction } from './../../store/action/CronosActions';
import { CronosListsPage } from './../cronos-lists/cronos-lists';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, ToastController, LoadingController } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { TeamModel, ProjectModel } from '../../model/CronosModel';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/AppStore';
import { LogoutAction } from '../../store/action/UserActions';
import { SurveyClearErrorsAction } from '../../store/action/SurveyActions';
import { TrainingClearErrorsAction } from '../../store/action/TrainingActions';
import { BrainstormClearErrorsAction } from '../../store/action/BrainstormActions';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { LoginPage } from '../login/login';
import { CronosService } from '../../services/CronosService';

@IonicPage()
@Component({
  selector: 'page-cronos-projects',
  templateUrl: 'cronos-projects.html',
})
export class CronosProjectsPage {

  public teamsList: Array<TeamModel> = [];
  public projectsList: Array<ProjectModel> = [];
  public searchInput: string = '';
  public shouldShowCancelSearch: boolean = false;
  public isLoading: boolean;
  public loader: Loading;

  private userId: number;
  private clientId: number;
  private loggingOff: boolean;
  private teamsLoaded: boolean;
  private projectsLoaded: boolean;
  private refresher: any = null;
  private clickedProjectId: number;

  private userSubscription: Subscription;
  private cronosSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private cronosService: CronosService
  ) {
  }

  ionViewDidLoad() {

    this.loggingOff = false;
    this.teamsLoaded = false;
    this.projectsLoaded = false;

    this.isLoading = false;
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.userId = userState.user.id;
        this.clientId = userState.user.clienteId;
        this.store.dispatch(new CronosListTeamsAction({ clientId: this.clientId }));
      }
    });

    if (this.navParams.get('projectId') != null) {
      this.clickedProjectId = this.navParams.get('projectId');
    }

  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (4)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewDidEnter() {

    this.cronosSubscription = this.store.select('cronosState').subscribe(cronosState => {
      if ((cronosState.loadingTeams || cronosState.loadingProjects) && !this.isLoading) {
        if (this.loader == null) {
          this.loader = this.loadingCtrl.create({
            content: "Aguarde..."
          });
          this.loader.present();
        }
        this.isLoading = true;
      }
      if (!cronosState.loadingTeams && !cronosState.loadingProjects && this.isLoading) {
        this.loader.dismiss();
        this.loader = null;
        this.isLoading = false;
      }
      if (cronosState.errorLoadingTeams || cronosState.errorLoadingProjects) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao trazer os projetos');
          }
        }, 200);
      }
      if (!this.teamsLoaded && cronosState.loadingTeams == false && cronosState.errorLoadingTeams == false && cronosState.teams != null) {
        this.teamsLoaded = true;
        this.teamsList = cronosState.teams;
        this.teamsList.push({
          clienteId: this.clientId,
          dataCadastro: new Date(),
          descricao: 'Planos Pessoais',
          id: 0,
          nome: 'Planos Pessoais',
          responsavel: '',
          usuarioId: this.userId,
          usuarios: [],
          usuariosAtivo: [],
          isOpen: false,
          projects: []
        });
        this.store.dispatch(new CronosListProjectsAction({ userId: this.userId }));
      } else if (this.teamsLoaded && !this.projectsLoaded && cronosState.loadingProjects == false && cronosState.errorLoadingProjects == false && cronosState.projects != null) {
        this.projectsLoaded = true;
        this.projectsList = cronosState.projects;
        this.projectsList.forEach(project => {
          project.categories = typeof project.categories == "string" ? JSON.parse(project.categories) : project.categories;

          if (project.teamId != null && !this.teamsList.find(x => x.id == project.teamId)) {
            this.teamsList.push({
              clienteId: this.clientId,
              dataCadastro: new Date(),
              descricao: project.team,
              id: project.teamId,
              nome: project.team,
              responsavel: '',
              usuarioId: this.userId,
              usuarios: [],
              usuariosAtivo: [],
              isOpen: false,
              projects: []
            });
          }
        });
        this.teamsList = this.teamsList.filter(x => x.id == 0 || this.projectsList.filter(p => p.teamId == x.id).length > 0);
        this.teamsList = this.teamsList.sort((a, b) => { return a.nome < b.nome ? -1 : 1; });
        this.search();
        if (this.refresher != null) {
          this.refresher.complete();
          this.refresher = null;
        }
        if (this.clickedProjectId != null) {
          const clickedProject: ProjectModel = this.projectsList.find(x => x.id == this.clickedProjectId);
          if (clickedProject != null) {
            const clickedTeam: TeamModel = this.teamsList.find(x => x.id == clickedProject.teamId);
            this.openProject(clickedProject, clickedTeam);
          }
        }
      }
    });

  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.cronosSubscription != null) this.cronosSubscription.unsubscribe();
  }

  refreshData(ref) {
    this.refresher = ref;
    this.projectsLoaded = false;
    this.store.dispatch(new CronosListProjectsAction({ userId: this.userId }));
  }

  search() {
    this.shouldShowCancelSearch = true;
    this.teamsList.forEach(team => {
      if (team.id == 0) {
        team.projects = this.projectsList
          .filter(x => x.teamId == null &&
            (x.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0 ||
              this.searchInput == '')
          )
          .sort((a, b) => { return a.name.localeCompare(b.name); });
      } else {
        team.projects = this.projectsList
          .filter(x => x.teamId == team.id &&
            (x.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0 ||
              this.searchInput == '')
          )
          .sort((a, b) => { return a.name.localeCompare(b.name); });
      }
    });
  }

  cancelSearch() {
    this.searchInput = '';
    this.shouldShowCancelSearch = false;
    this.search();
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  getStatusCount(project: ProjectModel, status: string) {
    let count: number = 0;
    project.summary = typeof project.summary != "object" ? JSON.parse(project.summary) : project.summary;
    count = project.summary[status];
    return count;
  }

  toggleSection(i) {
    this.teamsList[i].isOpen = !this.teamsList[i].isOpen;
  }

  openProject(project: ProjectModel, team: TeamModel) {
    let teamToOpen = Object.assign([], team);
    if (team.id == 0) {

      this.cronosService.listProjectUsers(project.id).subscribe(
        data => {

          teamToOpen.usuarios = [];
          data.forEach(user => {
            teamToOpen.usuarios.push({
              id: user.userId,
              clienteId: this.clientId,
              nome: user.userName,
              email: user.userEmail,
              emailAdmin: user.userEmail,
              senha: null,
              chave: null,
              dataCadastro: null,
              uriView: null,
              roles: null,
              autenticado: true,
              selected: null,
              deleted: null,
              enabled: false,
              responsavel: null,
              inactive: false,
              logoUrl: user.avatarUrl
            });
          });

          this.navCtrl.push(CronosListsPage, { project, team: teamToOpen });

        },
        err => {
          this.presentToast('Houve um erro ao listar os usuários do projeto');
        }
      );
    } else {
      this.navCtrl.push(CronosListsPage, { project, team: teamToOpen });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-projects/cronos-projects.ts